import React from 'react';
import {Col, Container, Row, Card, CardBody, Button, ButtonGroup} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {fetchAdminDataIfNeeded} from '../../redux/actions/AdminActions';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import * as TextManager from "../../modules/languages/TextManager";
import StoreTable from './components/StoresTable'
import HandleNameTable from './components/HandleNameTable'
import ManagerTable from './components/ManagersTable'
import StoreGroupsTable from './components/StoreGroupsTable'
import CellularRouteTable from './components/CellularRouteTable'

export class Settings extends ReactQueryParams {

    constructor(props) {
        super(props);

        this.state = {
            windowType: 1,   // 1 - stores, managers; 2 - name handle; 3 - upload pictures
            windowName: 'שם משווק וקבוצות חנויות',
            windowName2: 'מסלולי סלולר',
            searchValue: ''
        };
    }

    componentDidMount() {

        this.props.dispatch(fetchAdminDataIfNeeded(this.queryParams));
    }

    changeWindowType = () => {
        let currType = this.state.windowType;

        if(currType === 1) {
            this.setState({windowType: 2, windowName: 'הגדרות'})
        }
        else {
            this.setState({windowType: 1, windowName: 'שם משווק וקבוצות חנויות'})
        }
    };

    changeWindowType2 = () => {
        let currType = this.state.windowType;

        if(currType === 1) {
            this.setState({windowType: 3, windowName2: 'הגדרות'})
        }
        else {
            this.setState({windowType: 1, windowName2: 'מסלולי סלולר'})
        }
    };

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                }
                else if(typeof mr === 'number') {
                    if(parseInt(this.state.searchValue) === mr) {
                        retVal = retVal || true;
                    }
                }
                else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    render() {


        let stores = this.props.stores;
        let handleName = this.props.handleName;

        if (this.state.searchValue !== '' && this.state.windowType === 1) {
            stores = this.props.stores.filter(this.filterDataBySearch)
        }
        else if(this.state.searchValue !== '' && this.state.windowType === 2) {
            handleName = this.props.handleName.filter(this.filterDataBySearch)
        }

        return (
            <Container className='dashboard'>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'success' &&
                <span>
                    <Row>
                      <Col md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <Row>
                                    <Col md={10}>
                                        <ButtonGroup className='btn-group--icons' style={{marginTop: "10px"}}>
                                            <Button outline color='primary'
                                                    onClick={this.changeWindowType2}>{this.state.windowName2}</Button>
                                            <Button outline color='primary'
                                                    onClick={this.changeWindowType}>{this.state.windowName}</Button>
                                        </ButtonGroup>
                                    </Col>
                                     <Col md={2}>
                                        <h3 style={{textAlign: 'right'}}>{TextManager.getCurrentTextResource().Settings.settings}</h3>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardBody style={{padding: "1.25rem"}}>
                                <div style={{display: 'flex', height: '100%', justifyContent: 'flex-end'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                      <form className='topbar__search material-form'>
                                        <div
                                            className='search_field_form_control material-form__field topbar__search-field'>
                                            <div className='search_field_root search_field_custom-underline'
                                                 style={{border: 'groove'}}>
                                                <input className='search_field_custom-input' dir="rtl"
                                                       placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                                       value={this.state.searchValue}
                                                       onChange={(e) => this.changeSearch(e)}/>
                                            </div>
                                        </div>
                                      </form>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>
                    {this.state.windowType === 1 && <Row>
                        <Col md={12} xl={7} lg={12} xs={12}>
                            <StoreTable stores={stores}/>
                        </Col>
                        <Col md={12} xl={5} lg={12} xs={12}>
                            <ManagerTable/>
                        </Col>
                    </Row>}
                    {this.state.windowType === 2 && <Row style={{flexDirection:'row-reverse'}}>
                        <Col md={12} xl={4} lg={12} xs={12}>
                            <HandleNameTable handleName={handleName}/>
                        </Col>
                        <Col md={12} xl={4} lg={12} xs={12}>
                            <StoreGroupsTable/>
                        </Col>
                    </Row>}
                    {this.state.windowType === 3 && <Row>
                        <Col md={12} xl={7} lg={12} xs={12}>
                            <CellularRouteTable/>
                        </Col>
                    </Row>}
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.admin.status,
        stores: state.admin.stores,
        managers: state.admin.managers,
        handleName: state.admin.handleName,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(Settings))